var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToggleArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 7.051,
    viewBox: "0 0 12 7.051",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "free-icon-right-arrow-271228_1_",
    "data-name": "free-icon-right-arrow-271228 (1)",
    transform: "translate(0 7.051) rotate(-90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_991",
    "data-name": "\\uADF8\\uB8F9 991",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3248",
    "data-name": "\\uD328\\uC2A4 3248",
    d: "M6.859,6.468l-5.341,5.34a.658.658,0,0,1-.928,0L.2,11.415a.657.657,0,0,1,0-.928L4.682,6,.192,1.513a.658.658,0,0,1,0-.928L.585.192a.658.658,0,0,1,.928,0L6.859,5.537a.662.662,0,0,1,0,.932Z",
    fill: "#525868"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleArrow);
export default __webpack_public_path__ + "static/media/toggleArrow.f3213ea8f11b33164354b8b74b2ceb9f.svg";
export { ForwardRef as ReactComponent };